<template>
  <Grid v-bind="{ ...props }" @add-button-clicked="addClick" @edit-button-clicked="editClick" />
</template>

<script>
// Constants
import Constants from '../../constants/constants';

// Components
import Grid from '../shared/Grid.vue';

export default {
  name: 'CoolantSampleGrid',
  data() {
    return {
      props: {
        api: { ...Constants.Api.Endpoint.CoolantSample },
        columns: Constants.Grid.CoolantSample.columns,
        doClientSide: Constants.Grid.CoolantSample.doClientSide,
        filter: Constants.Grid.CoolantSample.filter,
        paging: Constants.Grid.CoolantSample.paging,
        searchHeader: Constants.Grid.CoolantSample.searchHeader,
        searchPlaceholder: Constants.Grid.CoolantSample.searchPlaceholder,
        sort: Constants.Grid.CoolantSample.sort,
        title: Constants.Grid.CoolantSample.title,
        addEditRoute: Constants.Api.Endpoint.CoolantSample.addEditRoute
      },
      idField: Constants.ColumnName.CoolantSample.coolantSampleId.field
    };
  },
  methods: {
    addClick(e) {
      window.open(Constants.Api.Endpoint.CoolantSample.addEditRoute, '_blank');
    },
    editClick(e, result) {
      const { coolantSampleID } = result.find(sample => e.sampleNumber === sample.sampleNumber);
      window.open(`${Constants.Api.Endpoint.CoolantSample.addEditRoute}?id=${coolantSampleID}`, '_blank');
    }
  },
  components: {
    Grid
  }
};
</script>
